import { render, staticRenderFns } from "./FormInputItem.vue?vue&type=template&id=32992a18&"
import script from "./FormInputItem.vue?vue&type=script&lang=js&"
export * from "./FormInputItem.vue?vue&type=script&lang=js&"
import style0 from "./FormInputItem.vue?vue&type=style&index=0&id=32992a18&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports